

























import {Component, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {Task, Location} from '@/store/types'
// const {Datetime} = require('vue-datetime')
import DateTime from '@/components/common/DateTime.vue'
import DateFormatter from '@/classes/DateFormatter'
import SurveyModel from '@/classes/SurveyModel'
import moment from 'moment'

@Component({
  components: {
    DateTime,
  },
})
export default class TaskDateTime extends Vue {
  @Getter('task') public task!: Task
  @Getter('location') public location!: Location
  @Action('updateTask') public updateTask!: any
  public dateTime: string|null = ''
  public SurveyModel = SurveyModel

  public $refs: any
  public get color() {
    if (!this.task.date || !this.task.date.length || !this.task.time || !this.task.time.length) {
      return 'danger'
    }
    if (this.task.status === SurveyModel.STATUS.PENDING) {
      return 'secondary'
    }
    return 'primary'
  }

  public get datepickerActive(): boolean {
    return (this.task.status === SurveyModel.STATUS.PENDING || this.task.status === SurveyModel.STATUS.ACTIVE)
  }
  public get minDate(): string {
    const dateFormatter = new DateFormatter()
    return dateFormatter.get()
  }
  public get maxDate(): string|null {
    const dateFormatter = new DateFormatter()
    return this.location.date_start.length ? dateFormatter.get(this.location.date_start) : null
  }

  public mounted() {
    this.$nextTick(() => {
      this.dateTime = this.task.date
      if (this.task.time) {
        this.dateTime += ' ' + this.task.time
      }
      if (this.dateTime) {
        this.dateTime = moment(this.dateTime).format()
      }

      if (this.datepickerActive) {
        this.$refs.dateTimeSet.firstChild.firstChild.style.display = 'none'
      }
    })
  }

  public saveDateTime() {
    if (!this.dateTime || !this.dateTime.length || this.dateTime === this.task.date) {
      return
    }
    const dateFormatter = new DateFormatter()
    const data = {
      date: dateFormatter.setServerTimezone().get(this.dateTime),
      time: dateFormatter.setServerTimezone().get(this.dateTime),
    }
    this.updateTask(Object.assign({}, this.task, data))
  }

  public showDateTimePicker() {
    this.$refs.dateTimeGet.style.display = 'none'
    this.$refs.dateTimeSet.firstChild.firstChild.style.display = 'block'
    this.$refs.dateTimeSet.firstChild.firstChild.click()
  }
}
